import {GuideFilter} from "../filters/GuideFilter";

export interface TechnologicalOperationGuideFilter extends GuideFilter {
    sortedField: TechnologicalOperationSortedField | null
}

export enum TechnologicalOperationSortedField {
    ID = "ID", NAME = "NAME"
}